export const isEqual = require('lodash.isequal');
